<template>
    <el-dialog title="报名记录" :visible.sync="dialogVisible" append-to-body>
        <el-button class="button" type="primary" size="small" @click="xiazai" style="margin-right: 10px;">导出表格</el-button>
        <el-tabs v-model="activeName" type="card">
            <el-tab-pane v-for="tab in tableData" :key="tab.group_id" :label="tab.title" :name="tab.group_id">
                <vxe-table :data="tab.ranking" border stripe resizable highlight-cell highlight-hover-row max-height="750" class="mytable-scrollbar" show-overflow keep-source align="center" :highlight-current-column="true">
                    <vxe-table-column field="id" title="ID" width="100">
                    </vxe-table-column>
                    <vxe-table-column field="apply_date" title="通过时间" width="150">
                    </vxe-table-column>
                    <vxe-table-column field="realname" title="姓名" min-width="100">
                    </vxe-table-column>
                    <vxe-table-column field="sex" title="性别" width="100">
                        <template slot-scope="scope">
                            {{ scope.row.sex == 1 ? '男':'女' }}
                        </template>
                    </vxe-table-column>
                    <vxe-table-column field="age" title="年龄" width="80">
                    </vxe-table-column>
                    <vxe-table-column field="idcard" title="身份证" width="200">
                    </vxe-table-column>
                    <vxe-table-column field="mobile" title="手机号" width="150">
                    </vxe-table-column>

                        <vxe-table-column field="custom_list" title="自定义收集信息" width="250">
                            <template slot-scope="scope">
                                <span v-for="(item,index) in scope.row.custom_list" :key="index">
                                    <span>{{item.name}}:{{item.value}};</span>
                                </span>
                            </template>
                        </vxe-table-column>


                    <!-- <vxe-table-column field="realname" title="实名" min-width="100">
                    </vxe-table-column>
                    <vxe-table-column field="facepic" title="头像" width="100">
                        <template slot-scope="scope">
                            <img v-if="scope.row.facepic" :src="$ReturnImgUrl(scope.row.facepic)" alt="" style="width: 50px; height: 50px;">
                        </template>
                    </vxe-table-column>
                    <vxe-table-column field="business_name" title="协会" min-width="150">
                    </vxe-table-column> -->

                    <vxe-table-column field="signin_status" title="是否签到" width="100">
                        <template slot-scope="scope">
                            {{ scope.row.signin_status == '1' ? '已签到':'未签到' }}
                        </template>
                    </vxe-table-column>
                    <vxe-table-column field="is_status" title="状态" width="100">
                        <template slot-scope="scope">
                            <span v-if="scope.row.is_status == 1">通过</span>
                            <span v-else-if="scope.row.is_status == 2">驳回</span>
                            <span v-else>报名</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column title="操作" min-width="180" fixed="right">
                        <template slot-scope="scope">
                            <div v-if="scope.row.is_status == 0" class="rou">
                                <button @click="shenhe(scope.row, 1, tab.group_id)" class="dsaggg mr">
                                    通过
                                </button>
                                <button @click="shenhe(scope.row, 2, tab.group_id)" class="dsaggg">
                                    驳回
                                </button>
                            </div>
                        </template>
                    </vxe-table-column>
                </vxe-table>
            </el-tab-pane>
        </el-tabs>

        <!-- <vxe-table :data="tableData" border stripe resizable highlight-cell highlight-hover-row max-height="750" class="mytable-scrollbar" show-overflow keep-source align="center" :highlight-current-column="true">
            <vxe-table-column field="id" title="ID" width="100">
            </vxe-table-column>
            <vxe-table-column field="act_name" title="姓名" min-width="100">
            </vxe-table-column>
            <vxe-table-column field="realname" title="实名" min-width="100">
            </vxe-table-column>
            <vxe-table-column field="facepic" title="头像" width="100">
                <template slot-scope="scope">
                    <img v-if="scope.row.facepic" :src="$ReturnImgUrl(scope.row.facepic)" alt="" style="width: 50px; height: 50px;">
                </template>
            </vxe-table-column>
            <vxe-table-column field="business_name" title="协会" min-width="150">
            </vxe-table-column>
            <vxe-table-column field="mobile" title="手机号" width="150">
            </vxe-table-column>
        </vxe-table>

        <div v-if="pageshow">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page" :page-sizes="[10]" layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div> -->

        <span slot="footer" class="dialog-footer">
            <el-button @click="handleCloseDialog">取 消</el-button>
            <el-button type="primary" @click="handleCloseDialog">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import { getActRanking, actEnrollAudit } from '@/api/huodongguanliBaomingjilu'

    export default {
        data() {
            return {
                dialogVisible: false,
                act_id: '',
                token: sessionStorage.getItem("token"),
                activeName: '',

                query: {
                    token: sessionStorage.getItem("token"),
                    act_id: '',
                    // page: 1,
                    // pagesize: 10
                },
                tableData: [],
                pageshow: false,
                total: null,
            }
        },
        created() {},
        methods: {
            // 导出
            xiazai() {
                window.location.href = `https://ydmxhapi.yundongm.cn:8099/service/admin/actEnrollExport?token=${this.token}&act_id=${this.act_id}&group_id=${this.activeName}`;
            },
            handleOpenDialog(row) {
                this.act_id = row.id;
                this.query.act_id = row.id;
                this.getList();
                this.dialogVisible = true;
            },
            handleCloseDialog() {
                this.dialogVisible = false;
            },

            getList() {
                getActRanking(this.query).then(({ data: res }) => {
                    this.tableData = res.data;
                    this.total = res.data.length;
                    if (this.tableData && this.tableData.length) {
                        this.activeName = this.tableData[0].group_id;
                    };

                })

            },
            handleSizeChange(val) {
                this.query.pagesize = val
                this.getList();
            },
            handleCurrentChange(val) {
                this.query.page = val
                this.getList();
            },

            shenhe(row, status, group_id) {
                const message = status == 1 ? "审核通过" : "审核驳回";
                this.$confirm("确认" + message + "吗?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                    })
                    .then(() => {
                        const obj = {
                            token: sessionStorage.getItem("token"),
                            ...row,
                            group_id,
                            is_status: status
                        };
                        actEnrollAudit(obj).then(({ data: res }) => {
                            if (res.result === -1) {
                                this.$message({
                                    message: res.msg,
                                    type: "error",
                                    duration: "2000",
                                });
                                setTimeout(() => {
                                    window.sessionStorage.clear();
                                    this.$router.push("/login");
                                }, 1000);
                            }
                            if (res.result === 0) {
                                this.$message({
                                    message: res.msg,
                                    type: "error",
                                    duration: "2000",
                                });
                                return false;
                            }
                            if (res.result === 1) {
                                this.$message({
                                    message: message,
                                    type: "success",
                                    duration: "2000",
                                });
                                this.getList();
                            }
                        });
                    })
                    .catch(() => {});
            }
        }
    }
</script>

<style lang="less" scope>
    .button{
        position: absolute;
        margin-left: 1020px;
        z-index: 999;
    }
    .rou {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        .mr {
            margin-right: 12px;
        }
    }

    .dsaggg {
        width: 78px;
        height: 37px;
        opacity: 1;
        border: 1px solid rgba(61, 154, 255, 0.5);
        border-radius: 2px;
        font-size: 12px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: center;
        color: #3d9aff;
        letter-spacing: 0px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #ffffff;
    }
</style>
